import { render, staticRenderFns } from "./class-header.vue?vue&type=template&id=0c1b466f&scoped=true&"
import script from "./class-header.vue?vue&type=script&lang=ts&"
export * from "./class-header.vue?vue&type=script&lang=ts&"
import style0 from "./class-header.vue?vue&type=style&index=0&id=0c1b466f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b466f",
  null
  
)

export default component.exports